<div class="loader-overlay" [class.full-screen]="fullScreen" role="alert" aria-busy="true">
  <div class="loader-content">
    <div class="logo-wrapper">
      <img src="../../../../assets/img/homeEos.svg" alt="Radoff Logo" class="loader-logo">
      <div class="spinner"></div>
    </div>
    <p *ngIf="message" class="loader-text">{{ message | translate }}</p>
  </div>
</div>